import React from 'react';
import '../styles/hero.css';
import logo from '../assets/logo.png';

const Hero = ({ scrollToCategories }) => {
  return (
    <section className="hero-section">
    <img src={logo} alt="Better Sleeping Logo" className="logo" />
    <p className="subtitle">
      Unlock Your Best Sleep With Expert Tips, Natural Remedies, And Proven Techniques
    </p>
    <button className="button" onClick={scrollToCategories}>Help Me Sleep</button>
    </section>
  );
  };
  
  export default Hero;
